/**
 * Reusable button style utilities
 * These styles are consistent with the design system used across the app
 */

export const BUTTON_STYLES = {
  // Primary action button (solid lime green)
  primary: 'bg-[#C0FD72] text-black hover:bg-[#b0ef62]',

  // Secondary button (dark with border)
  secondary: 'border border-border bg-card text-foreground hover:bg-card',

  // Outline button (transparent with border)
  outline: 'border border-[rgba(54,65,83,0.45)] bg-transparent text-foreground hover:bg-card',
}
